import store from '@/store';
import { v4 as uuid } from 'uuid';

export default {
  add() {
    const id = uuid();
    store.commit('preloader/add', id);
    return id;
  },

  remove(id) {
    store.commit('preloader/remove', id);
  },
};
